'use client'

import { EmptyState } from '@vinted/web-ui'

import { TranslationModel } from '@marketplace-web/catalog/catalog-data'

type Props = {
  translations?: TranslationModel
}

const FilterNoResults = ({ translations }: Props) => (
  <EmptyState
    title={translations?.noResults?.title}
    body={translations?.noResults?.body}
    testId="catalog-filter-no-results"
  />
)

export default FilterNoResults
